import axios from "axios";

const billingApi = axios.create({
  baseURL: process.env.REACT_APP_BILLING_API_URL || "",
  headers: { Accept: "application/json" },
});

billingApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default billingApi;
